import React from 'react'
import { ReadOnlyModel, useModelValue } from '@morningtrain/react-resources'
import moment from 'moment'
import { ScheduleColumn } from 'ui/schedule'
import { observer } from 'mobx-react'
import useActiveScheduleWeekday from 'support/hooks/use-active-schedule-weekday'
import CalendarDayContent from 'widgets/shifts/themes/calendar/CalendarDayContent'
import OnClickPipeline from 'support/pipelines/OnClickPipeline'
import { CallbackOnPipe } from '@morningtrain/react-helpers'
import { MountSmartviewWithModelOnPipe } from '@morningtrain/react-smartviews'
import ScheduleDaySummarySmartview from 'widgets/smartviews/shifts/ScheduleDaySummarySmartview'

function CalendarDay ({
  scheduleId,
  mode = 'view',
  scheduleModel
}) {
  const rawWeekday = useModelValue('key')
  const weekDay = moment(rawWeekday).day()

  const [activeScheduleWeekday, setActiveScheduleWeekday] = useActiveScheduleWeekday()

  if (mode === 'view') {
    return (
      <ScheduleColumn highlight={weekDay === activeScheduleWeekday}>
        <CalendarDayContent scheduleId={scheduleId} weekDay={weekDay} mode={mode} />
      </ScheduleColumn>
    )
  }

  return (
    <OnClickPipeline trigger={(
      <ScheduleColumn highlight={weekDay === activeScheduleWeekday}>
        <CalendarDayContent scheduleId={scheduleId} weekDay={weekDay} mode={mode} />
      </ScheduleColumn>
    )}
    >
      <CallbackOnPipe callback={() => setActiveScheduleWeekday(weekDay)} />
      <MountSmartviewWithModelOnPipe model={scheduleModel} smartview={<ScheduleDaySummarySmartview />} replace />
    </OnClickPipeline>
  )
}

export default observer(CalendarDay)
